<!-- TabPanels.svelte -->
<script lang="ts">
	import { getContext } from 'svelte'
	import type { TabContext } from '$lib/stores/tab-context'
	interface Props {
		children?: import('svelte').Snippet<[any]>
		[key: string]: any
	}

	let { ...props }: Props = $props()

	const { selected } = getContext<TabContext>('tabs')
</script>

<div class={props.class}>
	{@render props.children?.({ selected: $selected })}
</div>
